import { flatui_proxy } from '../../utils';

export const fetch_device_license = () => {
  const url = '/gui/adoms/devices/license';
  return flatui_proxy({
    url,
    method: 'get',
  });
};
